<template>
  <div class="edit-program-type g-edit-component">
    <!-- <div class="g-edit-component__top-bar">
    </div> -->
    <div class="g-two-columns">
      <div class="g-two-columns__column">
        <h2 class="edit-program-type__title">
          + {{ $t('messages.programEdit.setType.addProgram', {program: computedProgramTypeSelected.label}) }}
        </h2>

        <select-element
          :title="$t('messages.programEdit.setType.selectProgramType')"
          :value="String(ModalData.irrigationType)"
          :list="computedProgramSelectList"
          :emit-function-named="'setProgramSelect'"
          @setProgramSelect="setProgramSelect"
        />

        <p class="edit-program-type__text">
          {{ computedProgramTypeSelected.description }}
        </p>
      </div>
      <div class="g-two-columns__column">
        <div class="g-vertical-scroller">
          <input-element
            class="edit-program__top-bar__name"
            :name="'programName'"
            :title="$t('messages.programEdit.setType.programName')"
            :text="computedProgramName"
            :placeholder="$t('messages.sharedTexts.placeholders.nameMaxChars', {length: ModalData.capabilities.name.maxLength})"
            :max-length="ModalData.capabilities.name.maxLength"
            :emit-function-named="'SetProgramName'"
            @SetProgramName="SetProgramName"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {SocketHandler, LifeCycle} from '@/assets/javascript/mixins/Mixins'
import SelectElement from '@/components/elements/SelectElementReactive.vue'
// import RangeElement from '@/components/elements/RangeElement.vue'
import InputElement from '@/components/elements/InputElement.vue'

export default {
  name: 'EditProgramType',
  components:
  {
    'select-element': SelectElement,
    // 'range-element': RangeElement,
    'input-element': InputElement
  },
  mixins: [SocketHandler, LifeCycle],
  props:
  {
    SocketMessage: {
      type: Object,
      default: function() {
        return{}
      }
    },
    PageMessage: {
      type: Object,
      default: function() {
        return{}
      }
    },
    ModalData: {
      type: Object,
      default: function() {
        return{}
      }
    }
  },
  data() {
    return{
      // ProgramTypes (Select)
      ProgramNameData: {
        // prefix: '?', // Calculated?
        text: (this.ModalData.name) ? this.ModalData.name : '',
        emitFunctionNamed: 'SetProgramName',
        placeholder: this.$t('messages.sharedTexts.placeholders.nameMaxChars', {length: this.ModalData.capabilities.name.maxLength}),
        maxLength: this.ModalData.capabilities.name.maxLength
      },
      // Moisture control
      Moisturecontrol: true,
      MoistureToggleButtonState: false,
      // Water cut-off range (Selects)
      RangeDataLow: {
        emitFunctionNamed: 'SetRangeLow',
        title: this.$t('messages.programEdit.setType.moistureControl.onWhenUnder'),
        min: 0,
        max: 50,
        value: 10,
        type: 'flow',
        suffix: '%'
      },
      RangeDataHigh: {
        emitFunctionNamed: 'SetRangeHigh',
        title: this.$t('messages.programEdit.setType.moistureControl.offWhenOver'),
        min: 0,
        max: 50,
        value: 30,
        type: 'flow',
        suffix: '%'
      },
      Lock: true
    }
  },
  computed: {
    computedProgramSelectList() {
      return this.ModalData.capabilities.programTypes.map(programType => Object.assign({}, programType, {
        label: this.$t(`messages.programEdit.setType.programs.${programType.label.toLowerCase()}.title`),
        description: this.$t(`messages.programEdit.setType.programs.${programType.label.toLowerCase()}.description`)
      }))
    },
    computedProgramName() {
      return this.ModalData.name
    }, 
    computedProgramType() {
      return this.ModalData.irrigationType
    },
    computedProgramTypeSelected() {
      const type = this.computedProgramSelectList.find(programType =>
        parseInt(programType.value) === parseInt(this.ModalData.irrigationType))

      return type ? type : {
        value: this.ModalData.irrigationType,
        label: 'N/A'
      }
    }
  },
  methods: {
    MoistureToggleButtonClick() {
      this.MoistureToggleButtonState = !this.MoistureToggleButtonState
    },
    SetProgramName(text) {
      this.ModalData.name = text
      var msg = { Category: 'Irrigation', Type: 'IrrPgmData', Oper: 'Upd', Seq: this.ModalData.ID, Name: text }
      this.SocketMessageSend( msg )
    },
    setProgramSelect(data) {
      this.SocketMessageSend({
        Category: 'Irrigation',
        Type: 'IrrPgmData',
        Oper: 'Upd',
        Seq: this.ModalData.ID,
        IrrType: data.value
      })
    },
    SetRangeLow(Data) {
      this.RangeDataLow.value = Data
    },
    SetRangeHigh(Data) {
      this.RangeDataHigh.value = Data
    }
  }
}
</script>

<style lang="scss">
  .edit-program-type {
    hr {
      clear: both;
      border: 0;
    }

    &__continue {
      .svg-inline--fa {
        transform: translateY(2px);
        padding-left: 10px;
      }
    }

    &__title {
      color: $color-grey-darker;

      span {
        color: darken($color-grey-dark, 20);
        font-family: $font-primary-bold;
      }

      &--subtitle {
        margin-top: 0;
      }
    }

    .moisture-control-text {
      font-size: 14px;
      max-width: 85%;
      color: $color-grey-darker;
    }
  }

  @media screen and (min-width: $bp-desktop) {
    .edit-program-type {
      &__text {
        max-width: 70%;
      }
    }
  }
</style>
